













import Vue from 'vue'
import Cookie from 'js-cookie';
import SurveyDialog from './SurveyDialog.vue'
import { User } from '@/model/User';

enum SurveyType {
  Feedback = 'feedback',
  HowDidYouFindOut = 'howDidYouFindOut',
}
type DataState = {
  SurveyType: typeof SurveyType;
  timeouts: Record<SurveyType, NodeJS.Timeout | null>;
  dialogQueue: Array<SurveyType>;
  user: User | null;
}

const DISPLAY_FEEDBACK_AFTER_SECONDS = 1 * 60 * 1000;
const DISPLAY_HOW_DID_YOU_FIND_OUT_AFTER_SECONDS = 4 * 60 * 1000;

export default Vue.extend({
  name: 'Surveys',

  components: { SurveyDialog },

  data: (): DataState => ({
    SurveyType,
    timeouts: {
      feedback: null,
      howDidYouFindOut: null,
    },
    dialogQueue: [],
    user: null,
  }),

  computed: {
    isUserAuthenticated() {
      return this.$store.state.authentication.signedIn;
    },
  },

  watch: {
    isUserAuthenticated(value) {
      if (!value) {
        this.clearTimeouts();
        return;
      }

      this.setTimeouts();
    }
  },

  created() {
    this.setTimeouts();
  },

  beforeDestroy() {
    this.clearTimeouts();
  },

  methods: {
    shouldDisplaySurvey(type: SurveyType) {
      if (!this.$store.state.authentication.signedIn) return false;
      if (Cookie.get(this.getCookieKey(type)) === 'true') return false;

      return this.$store.state.authentication.user.surveys[type];
    },

    setTimeouts() {
      const shouldDisplayFeedback = this.shouldDisplaySurvey(SurveyType.Feedback);
      const shouldDisplayHowDidYouFindOut = this.shouldDisplaySurvey(SurveyType.HowDidYouFindOut);

      if (shouldDisplayFeedback || shouldDisplayHowDidYouFindOut) {
        this.$api
          .get('/users/nickname/' + this.$store.state.authentication.user.nickname)
          .then((response) => (this.user = response.data))
      }
      if (shouldDisplayFeedback) {
        this.timeouts.feedback = setTimeout(() => this.dialogQueue.push(SurveyType.Feedback), DISPLAY_FEEDBACK_AFTER_SECONDS)
      }
      if (shouldDisplayHowDidYouFindOut) {
        this.timeouts.howDidYouFindOut = setTimeout(() => this.dialogQueue.push(SurveyType.HowDidYouFindOut), DISPLAY_HOW_DID_YOU_FIND_OUT_AFTER_SECONDS)
      }
    },

    handleClose(type: SurveyType, forever = false) {
      this.dialogQueue = this.dialogQueue.filter(dialogType => dialogType !== type);
      Cookie.set(this.getCookieKey(type), 'true', { expires: forever ? 365 : 1 });
    },

    clearTimeouts() {
      if (this.timeouts.feedback) clearTimeout(this.timeouts.feedback);
      if (this.timeouts.howDidYouFindOut) clearTimeout(this.timeouts.howDidYouFindOut);
    },

    getCookieKey(type: SurveyType) {
      return 'dismissed-survey-' + type + '-' + this.$store.state.authentication.user.id;
    }
  }
})
